var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }